export default __webpack_public_path__ + "static/Quickinstallation_Tile_8015_Step_03-4195b342abbd15685a07d1c3c085d42a.webp";